import React from 'react'
import Markdown from 'react-markdown'
import PropTypes from 'prop-types'
import Layout from '../../components/layout'
import ContentfulClient from '../../contentful'
import { COOKIE_CONTENTFUL_ID } from '../../utils/vars'
import MetaHeaders from '../../components/metaheaders'
import Banner from '../../components/banner'
import LegalNav from '../../components/legalnav'

const CookiePolicy = ({
    metaTitle, metaDescription, bannerImage, body, pathname, title, subTitle,
}) => (
    <div className="legal">
        <MetaHeaders title={metaTitle} description={metaDescription} />
        <Layout>
            <Banner seoHeader={title} seoSub={subTitle} heading="Legal" bannerImage={bannerImage} small />
            <div className="container">
                <LegalNav selected={pathname} />
                <Markdown source={body} />
            </div>
        </Layout>
    </div>
)

CookiePolicy.getInitialProps = async (context) => {
    const res = await ContentfulClient.getEntry(COOKIE_CONTENTFUL_ID)

    return {
        ...res.fields,
        bannerImage: res.fields.bannerImage.fields.file.url,
        pathname: context.pathname,
    }
}

CookiePolicy.propTypes = {
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    bannerImage: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
}

export default CookiePolicy
